var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-dialog",
    {
      ref: "cargoDialog",
      staticClass: "grid-view",
      attrs: {
        "custom-class": "bill-payment-dialog-jc",
        visible: _vm.visible,
        title: _vm.title,
        width: "960px",
        top: "5vh",
        "can-maximize": _vm.source === "append",
        "can-minimize": _vm.source === "append",
        source: _vm.source
      },
      on: { close: _vm.cancel }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              attrs: { "active-name": _vm.activeTabName },
              on: { "tab-click": _vm.handleClick }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ApplicationForm"),
                    name: "applicationForm"
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        inline: true,
                        "label-width": "75px",
                        "label-position": "left",
                        disabled: _vm.readonly
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { flex: "1" } },
                            [
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.applicationNo")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "1",
                                          disabled: "disabled"
                                        },
                                        model: {
                                          value: _vm.billPayment.billPaymentNo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billPayment,
                                              "billPaymentNo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billPayment.billPaymentNo"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.status"),
                                        "label-width": "50px"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.stateText))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Payment.settleAccountsTo")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "2",
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "method-params": { customer: true },
                                          "default-value":
                                            Number(_vm.billPayment.accountId) ||
                                            "",
                                          "tag-name": "chineseName",
                                          disabled: ""
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.billPayment.accountId = p.value
                                            _vm.accountChange(p.value)
                                          }
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                            display: "flex",
                                            "justify-content": "space-between"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                no: "3",
                                                disabled:
                                                  !_vm.readonly &&
                                                  this.settlementAgentArray
                                                    .length == 0
                                              },
                                              on: {
                                                change:
                                                  _vm.cbSettlementAgentChange
                                              },
                                              model: {
                                                value: _vm.agentChecked,
                                                callback: function($$v) {
                                                  _vm.agentChecked = $$v
                                                },
                                                expression: "agentChecked"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Payment.bySettlementAgent"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("cargo-advance-select", {
                                            staticStyle: {
                                              "margin-left": "10px"
                                            },
                                            attrs: {
                                              no: "4",
                                              filterable: "",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Company,
                                              "default-value":
                                                Number(
                                                  _vm.billPayment
                                                    .settlementAgentId
                                                ) === 0
                                                  ? ""
                                                  : Number(
                                                      _vm.billPayment
                                                        .settlementAgentId
                                                    ),
                                              disabled: !_vm.agentChecked,
                                              cache: false,
                                              "tag-name": "chineseName",
                                              "static-options":
                                                _vm.settlementAgentArray
                                            },
                                            on: {
                                              parentCallBack: function(p) {
                                                _vm.billPayment.settlementAgentId =
                                                  p.value
                                                _vm.settlementAgentChange()
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Partners.paymentType")
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "2",
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_PaymentType,
                                          "default-value":
                                            _vm.billPayment.paymentType,
                                          "tag-name": "name"
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.billPayment.paymentType =
                                              p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Payment.businessType")
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      attrs: { no: "5", disabled: "" },
                                      model: {
                                        value: _vm.jobTypes,
                                        callback: function($$v) {
                                          _vm.jobTypes = $$v
                                        },
                                        expression: "jobTypes"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { no: "5a", label: "SE" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Payment.oceanExport")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { no: "5b", label: "SI" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Payment.oceanImport")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { no: "5c", label: "AE" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Payment.airExport"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { no: "5d", label: "AI" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Payment.airImport"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.currency")
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "115px" },
                                        attrs: {
                                          no: "6",
                                          filterable: "",
                                          clearable: false,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Currency,
                                          "default-value":
                                            _vm.billPayment.currency
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            return _vm.currencyChange(p.value)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: _vm.rateLabel } },
                                    [
                                      _c("num-input", {
                                        staticStyle: { width: "120px" },
                                        attrs: {
                                          no: "7",
                                          min: 0,
                                          max: 999999999,
                                          precision: 8,
                                          "truncated-precision":
                                            _vm.exchangeRatePrecision
                                        },
                                        on: { change: _vm.rateChange },
                                        model: {
                                          value: _vm.billPayment.rate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billPayment,
                                              "rate",
                                              $$v
                                            )
                                          },
                                          expression: "billPayment.rate"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("Payment.amount") }
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticStyle: { width: "115px" },
                                        attrs: {
                                          no: "8",
                                          precision: 2,
                                          disabled: "",
                                          controls: false
                                        },
                                        model: {
                                          value: _vm.billPayment.amount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billPayment,
                                              "amount",
                                              $$v
                                            )
                                          },
                                          expression: "billPayment.amount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.paymentPeriod")
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "9",
                                          type: "date",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.billPayment.deadline,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billPayment,
                                              "deadline",
                                              $$v
                                            )
                                          },
                                          expression: "billPayment.deadline"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.methodOfPayment")
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "170px" },
                                          attrs: { no: "10" },
                                          model: {
                                            value: _vm.billPayment.payType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billPayment,
                                                "payType",
                                                $$v
                                              )
                                            },
                                            expression: "billPayment.payType"
                                          }
                                        },
                                        _vm._l(_vm.receiveTypes, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: Number(item.code)
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.invoiceHeader")
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "28",
                                          "allow-create": true,
                                          "select-type":
                                            _vm.selectTypeNames
                                              .static_data_Title,
                                          filterable: "",
                                          cache: false,
                                          "default-value":
                                            _vm.billPayment.invoiceTitle,
                                          "static-options": _vm.titleArray
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            _vm.billPayment.invoiceTitle =
                                              p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.bankAccount")
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "170px" },
                                        attrs: { no: "12" },
                                        model: {
                                          value:
                                            _vm.billPayment.buyerBankAccount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billPayment,
                                              "buyerBankAccount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "billPayment.buyerBankAccount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.bankOfDeposit")
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "11",
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .static_data_TitleBank,
                                          "default-value": _vm.buyerBankUuid,
                                          cache: false,
                                          "static-options": _vm.titleBankArray,
                                          "tag-value": "uuid",
                                          "tag-name": "bank",
                                          headers: ["币种", "银行名称"],
                                          fields: ["currency", "bank"]
                                        },
                                        on: {
                                          parentCallBack: _vm.titleBankChange
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Payment.dateOfApplication"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "14",
                                          type: "date",
                                          clearable: false
                                        },
                                        model: {
                                          value: _vm.billPayment.inputDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.billPayment,
                                              "inputDate",
                                              $$v
                                            )
                                          },
                                          expression: "billPayment.inputDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.applicant")
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "13",
                                          "select-type":
                                            _vm.selectTypeNames.basic_data_User,
                                          "default-value":
                                            Number(_vm.billPayment.inputBy) ||
                                            "",
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.toExoSystemYGSH
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_PaymentBranch"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "170px" },
                                              attrs: { no: "15" },
                                              model: {
                                                value:
                                                  _vm.billPayment
                                                    .settleDepartmentPrefix,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billPayment,
                                                    "settleDepartmentPrefix",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billPayment.settleDepartmentPrefix"
                                              }
                                            },
                                            _vm._l(
                                              _vm.paymentBranchType,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label:
                                                      _vm.$store.getters
                                                        .language === "zh"
                                                        ? item.chineseName
                                                        : item.englishName,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Remarks2"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "170px" },
                                              attrs: { no: "16" },
                                              model: {
                                                value:
                                                  _vm.billPayment.recordType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billPayment,
                                                    "recordType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billPayment.recordType"
                                              }
                                            },
                                            _vm._l(
                                              _vm.sendRemarkTypes,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label:
                                                      _vm.$store.getters
                                                        .language === "zh"
                                                        ? item.chineseName
                                                        : item.englishName,
                                                    value:
                                                      _vm.$store.getters
                                                        .language === "zh"
                                                        ? item.chineseName
                                                        : item.englishName
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("Payment.totalCurrency")
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { width: "170px" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.billPayment.currencyAmount
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openSapConfig,
                                          expression: "openSapConfig"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.$t(
                                          "Payment.settleDepartmentPrefix"
                                        )
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          no: "17",
                                          filterable: "",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Department,
                                          "default-value":
                                            _vm.billPayment
                                              .settleDepartmentPrefix || "",
                                          cache: false,
                                          "static-options": _vm.departmentArray,
                                          "tag-name": "chineseName",
                                          "tag-value": "jobNoPrefix"
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.settleDepartmentPrefixChange
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("div", { staticStyle: { width: "290px" } }, [
                            _c(
                              "div",
                              { staticClass: "el-form-item-wrapper" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { "label-width": "0" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "bold",
                                          color: "darkred",
                                          "font-size": "14px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Payment.couldNotSearhWriteOffJobFromThisWindow"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm.toExoSystemYGSH
                              ? _c(
                                  "div",
                                  { staticClass: "el-form-item-wrapper" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "custom-textarea",
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ApplicationDetails"
                                          ),
                                          "label-width": "100px"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "290px" },
                                          attrs: {
                                            no: "18",
                                            type: "textarea",
                                            rows: 5
                                          },
                                          model: {
                                            value: _vm.billPayment.sendRemark,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billPayment,
                                                "sendRemark",
                                                $$v
                                              )
                                            },
                                            expression: "billPayment.sendRemark"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "custom-textarea",
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_Remarks2"
                                          ),
                                          "label-width": "100px"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "290px" },
                                          attrs: {
                                            no: "19",
                                            type: "textarea",
                                            rows: 5
                                          },
                                          model: {
                                            value: _vm.billPayment.remark,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billPayment,
                                                "remark",
                                                $$v
                                              )
                                            },
                                            expression: "billPayment.remark"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "el-form-item-wrapper" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "custom-textarea",
                                        attrs: {
                                          label: _vm.$t("Payment.remarks"),
                                          "label-width": "100px"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "290px" },
                                          attrs: {
                                            no: "20",
                                            type: "textarea",
                                            rows: 12
                                          },
                                          model: {
                                            value: _vm.billPayment.remark,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.billPayment,
                                                "remark",
                                                $$v
                                              )
                                            },
                                            expression: "billPayment.remark"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ])
                        ]
                      )
                    ]
                  ),
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "flex-grow": "1"
                    },
                    attrs: {
                      "config-module": "190805",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      }
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        "margin-top": "10px"
                      }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.$t("Payment.total")))]),
                      _c("charge-currency-total-group", {
                        key: 1,
                        attrs: {
                          "ar-field": "chargeReceivable",
                          "data-field": "chargeAmount",
                          "currency-field": "chargeCurrency",
                          "rate-field": "chargeRate",
                          "arap-order": "ap",
                          type: "auto",
                          "data-provider": _vm.rowData
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.billPayment.uuid
                ? _c(
                    "el-tab-pane",
                    {
                      staticStyle: { height: "503px" },
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FileHistory"),
                        name: "fileHistory",
                        lazy: true
                      }
                    },
                    [
                      _c("file-history", {
                        attrs: {
                          "bill-payment-uuid": _vm.billPaymentUuid,
                          "bill-payment-state": _vm.billPayment.state,
                          "input-by": _vm.$store.getters.userId,
                          "file-history-jc": true,
                          "grid-height": "460px"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.billPayment.uuid
                ? _c(
                    "el-tab-pane",
                    {
                      staticStyle: { height: "503px" },
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ApprovalHistory"),
                        name: "approvalList",
                        lazy: true
                      }
                    },
                    [
                      _c("approval-history", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "bill-payment-uuid": _vm.billPaymentUuid,
                          "approve-history-jc": true,
                          "grid-height": "503px"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _vm.billPayment.uuid &&
        _vm.billPayment.state == 0 &&
        _vm.step === "step2" &&
        _vm.mode === "edit"
          ? _c(
              "span",
              { staticStyle: { position: "absolute", left: "20px" } },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.activeTabName === "applicationForm" &&
                          _vm.billPayment.uuid &&
                          _vm.billPayment.state == 0,
                        expression:
                          "activeTabName==='applicationForm' && billPayment.uuid && billPayment.state == 0"
                      }
                    ],
                    attrs: { no: "21", type: "primary" },
                    on: { click: _vm.addCharge }
                  },
                  [_vm._v(_vm._s(_vm.$t("Payment.addCharge")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.activeTabName === "applicationForm" &&
                          _vm.billPayment.uuid &&
                          _vm.billPayment.state == 0,
                        expression:
                          "activeTabName==='applicationForm' && billPayment.uuid && billPayment.state == 0"
                      }
                    ],
                    attrs: { no: "22", type: "primary" },
                    on: { click: _vm.removeCharge }
                  },
                  [_vm._v(_vm._s(_vm.$t("Payment.removeCharge")))]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "span",
          { staticStyle: { "padding-right": "10px" } },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.activeTabName === "applicationForm" &&
                      !_vm.billPayment.uuid &&
                      _vm.step === "step2" &&
                      _vm.mode === "edit",
                    expression:
                      "activeTabName==='applicationForm' && !billPayment.uuid && step === 'step2' && mode === 'edit'"
                  }
                ],
                attrs: { no: "23", type: "primary" },
                on: { click: _vm.toPreStep }
              },
              [_vm._v(_vm._s(_vm.$t("Payment.back")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.activeTabName === "applicationForm" &&
                      _vm.billPayment.uuid,
                    expression:
                      "activeTabName==='applicationForm' && billPayment.uuid"
                  }
                ],
                attrs: { no: "24", type: "primary" },
                on: { click: _vm.doPrint }
              },
              [_vm._v(_vm._s(_vm.$t("Payment.print")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.activeTabName === "applicationForm" &&
                      _vm.billPayment.uuid &&
                      _vm.billPayment.state == 0,
                    expression:
                      "activeTabName==='applicationForm' && billPayment.uuid && billPayment.state == 0"
                  }
                ],
                attrs: { no: "25", type: "primary" },
                on: { click: _vm.doCommit }
              },
              [_vm._v(_vm._s(_vm.$t("Payment.submit")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTabName === "applicationForm",
                    expression: "activeTabName==='applicationForm'"
                  }
                ],
                attrs: {
                  no: "26",
                  type: "primary",
                  disabled: _vm.readonly || _vm.btnSaveEnable
                },
                on: { click: _vm.doSave }
              },
              [_vm._v(_vm._s(_vm.$t("Payment.save")))]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "27", type: "primary" },
                on: { click: _vm.cancel }
              },
              [_vm._v(_vm._s(_vm.$t("Payment.cancel")))]
            )
          ],
          1
        )
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.joinChargeDialog.visible
        ? _c("join-charge-dialog", {
            attrs: {
              visible: _vm.joinChargeDialog.visible,
              "search-item-module": "5043",
              "default-conditions": _vm.joinChargeDialog.addChargeCondition,
              "charge-state-param": "BillPaymentChargeState"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.joinChargeDialog, "visible", $event)
              },
              addChargeCallBackEvent: _vm.addChargeCallBack
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }